import {GET_COUNTRIES_REQ} from "./countriesTypes";

const initialState = {
    countriesList : []
}

const countriesReducer = (state = initialState, action) => {

    switch (action.type) {
        case GET_COUNTRIES_REQ: return {
            ...state,
            countriesList: action.payload.data
        }
        default:
            return state;
    }
}

export default countriesReducer
